export const FM_HEADER_TOP_0 = {
  header: {
    top: "0px",
  },
};
